import React from 'react';
import { useEffect, useState } from 'react';
import Service from '../Service/Service';
import './Services.css';

const Services = () => {
    const [services, setServices] = useState([]);
    useEffect(() => {
        fetch('services.json')
            .then(res => res.json())
            .then(data => setServices(data));

    }, [])
    return (
        <div id="services" className='container'>
            <div className="row">
                <div id="services" className='container'>
                    <div className="row">
                        <h1 className='text-primary text-center mt-5 mb-4'> Our Services</h1>
                        <div className="services-container">
                            {
                                services.map(service => <Service
                                    key={service.id}
                                    service={service}
                                >
                                </Service>)
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Services;